import React, { Fragment, useEffect, useState } from 'react'
import { Button, Modal, Card, Form, Row, Col, Spinner, Toast } from 'react-bootstrap'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { useDispatch, useSelector } from 'react-redux'
import Mensajes from '../mensajes'

import { serviceGetApoderados, servicesAsignarApoderado } from '../../api/api-consultar-caso';

const ModalAsignaApoderado = ({showAsignarApoderado, handleCloseAsignarApoderado, antecedentesCaso, setReloadCaso}) => {
    const { rutUsuario, rutOrganizacion } = Auth.currentUser()
    const [loading, setLoading]=useState(false)

    // Validaciones seguras: antecedentesCaso puede ser null/undefined o tener estructura distinta
    const tieneAntecedentesArray = Array.isArray(antecedentesCaso) && antecedentesCaso.length > 0;
    const primerAntecedente = tieneAntecedentesArray ? antecedentesCaso[0] : null;

    const [apoderados, setApoderados] = useState([]);
    const [loadingApoderados, setLoadingApoderados] = useState(false);
    const [selectedApoderado, setSelectedApoderado] = useState('');
    const [comentario, setComentario] = useState('');

    const [showToast, setShowToast] = useState(false);
    const handleCloseToast = () => setShowToast(false)
    const handleShowToast = () => setShowToast(true)
    const [responseData, setResponseData] = useState(false);

    useEffect(() => {
        // Cargar apoderados cuando se abre el modal y exista organización
        if (showAsignarApoderado && rutOrganizacion) {
            setLoadingApoderados(true);
            const query = Buffer.from(JSON.stringify({ idOrganizacion: rutOrganizacion, rol: '70ABOAPOCIA', tipoPersona: '0080PROVE00' })).toString('base64');
            serviceGetApoderados(query)
                .then(resp => {
                    const lista = Array.isArray(resp) ? resp : (resp && resp.object ? resp.object : []);
                    
                    // eliminar de la lista el apoderado actual (primerAntecedente['ApoderadoCia'])
                    const valorActual = primerAntecedente ? String(primerAntecedente['ApoderadoCia'] || '').trim() : null;
                    let listaFiltrada = lista;
                    if (valorActual) {
                        listaFiltrada = lista.filter(a => {
                            const nombre = String(a.nombre || '').trim();
                            return nombre !== valorActual;
                        });
                    }
                    setApoderados(listaFiltrada);
                })
                .catch(err => {
                    console.error('Error al obtener apoderados', err);
                    setApoderados([]);
                })
                .finally(() => setLoadingApoderados(false));
        }
    }, [showAsignarApoderado, rutOrganizacion, primerAntecedente]);

    const onAsignar = () => {
      
      if (selectedApoderado) {
        const apoderadoSeleccionado = apoderados.find(a => a.id === Number(selectedApoderado) || a.rut === Number(selectedApoderado));

        if (primerAntecedente['ApoderadoCia'] == apoderadoSeleccionado.nombre) {
          alert("Debe seleccionar apoderado diferente.");
          return
        }
        
        if (typeof servicesAsignarApoderado === 'function' && selectedApoderado && apoderadoSeleccionado) {
            
            setReloadCaso(false);
            setLoading(true);
            servicesAsignarApoderado({ idCaso: primerAntecedente.IdCaso, apoderadoSeleccionado, comentario })
            .then(resp => {
              setResponseData(resp);
              setShowToast(true);
              setReloadCaso(true);
              handleCloseAsignarApoderado();
            })
            .catch(err => {
              console.log("Error al actualizar Apoderado.", err);
              alert("Error al actualizar Apoderado.");
            })
            .finally(() => limpiar());

        } else {
            console.log("Ingrese datos!.");
        }
      }
    }   
    const limpiar = () => {
      setLoading(false);
      setSelectedApoderado("");
      setComentario("");
    }

    return (
      <Fragment>
      <div>
        <LoadingComponent show={loading}/>
        <Modal size="xl" show={showAsignarApoderado} onHide={handleCloseAsignarApoderado}>
          <Card>
              <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                  Asignar / Reasignar Apoderado Siniestro { primerAntecedente ? primerAntecedente['Siniestro'] : '' }
              </Card.Header>
              <Card.Body>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>Apoderado Siniestro</Form.Label>{' '}
                    <br />
                    <Form.Text className='mb-3'>
                      { primerAntecedente ? primerAntecedente['ApoderadoCia'] : '' }
                    </Form.Text>
                  </Col>

                  <Col md={6}>
                    <Form.Group>
                      <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>Seleccionar Apoderado</Form.Label>
                      { loadingApoderados ? (
                          <div><Spinner animation="border" size="sm" /> Cargando...</div>
                      ) : (
                          <Form.Select
                              value={selectedApoderado}
                              onChange={(e) => setSelectedApoderado(e.target.value)}
                          >
                              <option value=''>-- Seleccione --</option>
                              { apoderados.map((a, idx) => {                                
                                  return <option key={idx} value={a.id}>{a.nombre}</option>
                              })}
                          </Form.Select>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Form.Group>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>Comentario</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={comentario}
                            onChange={(e) => setComentario(e.target.value)}
                            placeholder="Ingrese comentario (opcional)"
                        />
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
          </Card>
          {responseData && 
              <Mensajes
                  showToast={showToast}
                  handleCloseToast={handleCloseToast}
                  delay={5000}
                  responseData={responseData}
              ></Mensajes>
            }
          
          <Modal.Footer>
            <Button className='m-2 w-auto' variant='outline-info' onClick={handleCloseAsignarApoderado}>Cerrar</Button>
            <Button className='m-2' variant='buscar' onClick={onAsignar} name='actualizar'>Actualizar</Button>
          </Modal.Footer>
          
        </Modal>
      </div>
      <style type='text/css'>
      
            {`
              .btn-buscar {
                background-color: #C14B49;
                color: #FFFFFF;
                width: 140px;
                padding:6px 0px 6px 0px;
              }
              .btn-buscar:hover{
                background-color:  #F6897E;
                color: #FFFFFF;
              }
              .toast {
                  --bs-toast-max-width: 600px;
                  width: 600px;
              }
            `}
        </style>
      </Fragment>
    )
}

export default ModalAsignaApoderado